// legacy
require('select2/dist/js/select2.min');

$(document).ready(($) => {
  const convertJsendToSelectTwo = function convertJsendAJAXDataToSelectTwo(data) {
    if ('success' === data.status) {
      const results = [];

      data.data.results.forEach((jsendData) => {
        results.push({
          id: jsendData.id,
          text: `${jsendData.companyName} - ${jsendData.subscriptionName} (${jsendData.id})`,
        });
      });

      return {
        results,
        pagination: {
          more: data.data.pagination.more,
        },
      };
    }

    return {
    };
  };

  const $inputs = $('[data-select-select2]');

  $inputs.each((index, element) => {
    const $input = $(element);
    const uri = $input.data('selectSelect2');

    $input.select2({
      ajax: {
        url: uri,
        data: (params) => ({
          search: params.term,
          page: params.page || 1,
        }),
        delay: 150,
        processResults: convertJsendToSelectTwo,
      },
    });
  })
    .on('select2:select', (e) => {
      $('[data-select-select2-value]').val(e.params.data.id);
    });
});
